import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';

export default function PendingApprovalPage() {
  const { user, recheckApproval, signOut } = useAuth();

  // Verifica a cada 30s se o admin já aprovou
  useEffect(() => {
    const id = setInterval(recheckApproval, 30000);
    return () => clearInterval(id);
  }, [recheckApproval]);

  return (
    <div style={pg.overlay}>
      <div style={pg.card}>
        <div style={pg.icon}>⏳</div>
        <h2 style={pg.title}>Conta Aguardando Aprovação</h2>
        <p style={pg.text}>
          Seu cadastro foi recebido e seu e-mail confirmado com sucesso.
          Um administrador irá revisar e liberar o acesso em breve.
        </p>
        {user?.email && (
          <div style={pg.emailBox}>
            <span style={pg.emailLabel}>Conta cadastrada</span>
            <strong style={pg.email}>{user.email}</strong>
          </div>
        )}
        <p style={pg.hint}>
          Esta página verifica automaticamente a aprovação a cada 30 segundos.
          Você também pode fechar o navegador e retornar após receber confirmação.
        </p>
        <button className="btn btn-secondary" style={{ width: '100%', justifyContent: 'center' }} onClick={signOut}>
          Sair
        </button>
      </div>
    </div>
  );
}

const pg = {
  overlay: {
    minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: 'var(--bg)', padding: 24,
  },
  card: {
    background: 'var(--surface)', borderRadius: 16, padding: '40px 36px',
    maxWidth: 440, width: '100%', textAlign: 'center',
    boxShadow: '0 4px 24px rgba(0,0,0,.08)', border: '1px solid var(--border)',
  },
  icon: { fontSize: 52, marginBottom: 20 },
  title: { fontSize: 22, fontWeight: 700, color: 'var(--text)', margin: '0 0 14px' },
  text: { fontSize: 14, color: 'var(--text-2)', lineHeight: 1.7, margin: '0 0 24px' },
  emailBox: {
    display: 'flex', flexDirection: 'column', gap: 4,
    padding: '14px 20px', background: 'var(--bg)', borderRadius: 10,
    border: '1px solid var(--border)', marginBottom: 20,
  },
  emailLabel: { fontSize: 11, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '.06em' },
  email: { fontSize: 15, color: 'var(--navy)' },
  hint: {
    fontSize: 12, color: 'var(--text-3)', lineHeight: 1.6,
    margin: '0 0 24px',
  },
};
